import HappyCityIcon from '@stencil/icons/src/HappyCityIcon/HappyCityIcon';
import HappyMapPointerIcon from '@stencil/icons/src/HappyMapPointerIcon/HappyMapPointerIcon';
import HappyHotelSearchIcon from '@stencil/icons/src/HappyHotelSearchIcon/HappyHotelSearchIcon';
import HappyFlightIcon from '@stencil/icons/src/HappyFlightIcon/HappyFlightIcon';

const AutosuggestIconSelector = ({
  name,
  ...styleProps
}: {
  name: 'area' | 'city' | 'landmark' | 'hotel' | 'airport' | 'poi';
}) => {
  switch (name) {
    case 'area':
    case 'city':
      return <HappyCityIcon {...styleProps} />;
    case 'poi':
    case 'landmark':
      return <HappyMapPointerIcon {...styleProps} />;
    case 'hotel':
      return <HappyHotelSearchIcon {...styleProps} />;
    case 'airport':
      return <HappyFlightIcon {...styleProps} />;
    default:
      return <HappyCityIcon {...styleProps} />;
  }
};

export default AutosuggestIconSelector;
